<template>
  <!--个人信息修改页-->
    <el-container>
      <el-header>
          <el-button type="primary" @click="avatarDialogVisible = true">修改头像</el-button>
          <el-button type="success" @click="changePass = false">修改昵称或密码</el-button>
          <el-button type="info" @click="phoneDialogVisible = true">绑定手机号</el-button>
          <el-button type="warning" @click="emailDialogVisible = true">绑定邮箱</el-button>
        <div class="div_loginOut">
          <el-button type="danger" @click="loginOut">退出登录</el-button>
        </div>
      </el-header>
      <el-main>
        <div>
          <div class="div_img_avatar">
            <img :src="imgUrl" alt="">

          </div>
          <div class="div_userinfo_form">
            <el-form :model="user" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="昵称" prop="user">
                <el-input type="text" v-model="user.username" :disabled="changePass" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="pass">
                <el-input type="password" v-model="user.pass" :disabled="changePass" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="checkPass">
                <el-input type="password" v-model="user.checkPass" :disabled="changePass" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="手机号">
                <el-input v-model.number="user.phone" :disabled="true" placeholder="手机号"></el-input>
              </el-form-item>
              <el-form-item label="邮箱">
                <el-input v-model="user.email" :disabled="true" placeholder="绑定邮箱"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">修改</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-dialog
              title="修改头像"
              :visible.sync="avatarDialogVisible"
              width="30%"
              center>
            <el-upload ref="upfile"
                       action="#"
                       :auto-upload="false"
                       :on-change="handleChange"
                       :show-file-list="false"
                       :limit="1"
                       accept="image/png,image/gif,image/jpg,image/jpeg"
            >
              <img v-if="fileImg" :src="fileImg" width="180px" height="180px"/>
              <i v-else class="el-icon-plus" style="font-size: xxx-large;margin-top: 70px"></i>
            </el-upload>
            <span slot="footer" class="dialog-footer">
              <el-button @click="avatarDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="changeAvatar">确 定</el-button>
            </span>
          </el-dialog>
          <el-dialog
              title="修改手机号"
              :visible.sync="phoneDialogVisible"
              width="30%"
              center>
            <el-input v-model.number="phoneCode.phone"  :placeholder="user.phone?user.phone:'请输入手机号'"></el-input>
            <el-input v-model="phoneCode.code" placeholder="点击获取">
              <template slot="prepend">验证码</template>
              <el-button slot="append" icon="el-icon-message"
                         @click="sendSMS">
              </el-button>
            </el-input>
            <span slot="footer" class="dialog-footer">
              <el-button @click="phoneDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="changePhone">确 定</el-button>
            </span>
          </el-dialog>
          <el-dialog
              title="修改邮箱"
              :visible.sync="emailDialogVisible"
              width="30%"
              center>
            <el-input v-model="emailCode.email"  :placeholder="user.email?user.email:'请输入邮箱'"></el-input>
            <el-input v-model.number="emailCode.code" placeholder="点击获取">
              <template slot="prepend">验证码</template>
              <el-button slot="append" icon="el-icon-message"
                         @click="sendEmail">
              </el-button>
            </el-input>
            <span slot="footer" class="dialog-footer">
              <el-button @click="emailDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="changeEmail">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </el-main>

    </el-container>
</template>

<script>

export default {
  name: "UserInfo",

  data(){

    //手机号校验规则
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      //校验手机号
      var myreg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      setTimeout(() => {
        if (!myreg.test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          this.show = true;
          callback();
        }
      }, 1000);
    };
    var checkEmail = (rule, value, callback) => {
      if( !value || value === ''){
        return callback(new Error('请输入邮箱号'));
      }
      //校验邮箱
      var myreg = /^([a-zA-Z\d][\w-]{2,})@(\w{2,})\.([a-z]{2,})(\.[a-z]{2,})?$/;
      console.log(myreg.test(value))
      if(!myreg.test(value)) {
        callback(new Error('请输入正确的邮箱'));
      } else {
        this.eshow = true;
        callback();
      }
    };
    return {
      eshow: false, //邮箱验证码的按钮显示
      countEmail: '',
      changePass:true,
      avatarDialogVisible:false,
      phoneDialogVisible:false,
      emailDialogVisible:false,
      fileList:[],
      fileImg:'',

      user:this.$store.state.UserInfo.user ? this.$store.state.UserInfo.user.user : {},
      imgUrl:this.$store.state.UserInfo.user ? this.$store.state.UserInfo.user.user.avatar : '',
      ruleForm: {
        pass: '',
        checkPass: '',
        age: ''
      },
      phoneCode:{
        id: '',
        phone: '',
        code: ''
      },
      emailCode:{
        id: '',
        email:'',
        code: ''
      },

      rules: {
        phone: [
          { validator: checkPhone,trigger: 'blur'}
        ],
        email: [
          { validator: checkEmail,trigger: 'blur'}
        ]
      },
      rulesPhone: {
        phone: [
          { validator: checkPhone,trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    handleChange(file,fileList) {
      const isLt2M = file.size / 1024 / 1024 < 2     //这里做文件大小限制
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        });
        this.$refs.upfile.clearFiles();
        return isLt2M
      } else {
        //多次上传
        this.$refs.upfile.clearFiles(); //上传成功之后清除历史记录

        this.fileList = fileList;
        //生成本地图片的url，直接src显示,删除或移动后url就失效了
        this.fileImg = URL.createObjectURL(file.raw);

      }
    },
    sendSMS(){
      //校验手机号
      var myreg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if(!myreg.test(this.phoneCode.phone)){
        console.log('error submit!!')
        this.$message.error('请填写正确的手机号');
      }else {
        //点击发送短信验证码
        this.successShow()
      }

    },
    sendEmail(){
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if(!this.emailCode.email || !reg.test(this.emailCode.email)){
        this.$message.error('请输入正确的邮箱')
      }else {
        this.axios.post("/userinfo/getEmailCode/" + this.emailCode.email + '').then(res => {
          if(res.data.code === 0){
            this.$message.success("验证码发送成功")
          }
        })
      }

    },

    successShow() {
      this.axios.post('/register/sendSMS/' + this.phoneCode.phone + '').then(res => {
        if (res.data.code === 0) {
          //console.log(res.data)
          this.$message(res.data.message)
          this.$message.success('验证码发送成功，请注意查收');
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    submitForm(formName) {
      //修改昵称和密码
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var fd = new FormData()
          fd.append('info',JSON.stringify(this.user))
          this.axios.post('/userinfo/changeUsernamePass',fd).then(res => {
            if(res.data.code === 0){
              this.$message.success("修改成功")
              this.changePass = true
            }else {
              this.$message.error(res.data.message)
            }
          })
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    changeAvatar(){
      if(!this.fileImg){
        this.$message.error('请上传图片')
      }else{
        this.avatarDialogVisible = false
        //提交请求
        var fd = new FormData()
        var face = this.fileList[0];
        fd.append('info',JSON.stringify(this.user))
        fd.append('avatar',face.raw)
        this.axios.post('/userinfo/changeAvatar',fd).then(res => {
          if(res.data.code === 0){
            this.$message.success('修改成功')
            this.imgUrl = this.fileImg
            this.fileImg = ''
          }else {
            this.$message.error(res.data.message)
          }
        })
      }

    },
    changePhone(){
      if(!this.phoneCode.phone){
        this.$message.error('请输入手机号')
      }else {
        this.phoneCode.id = this.user.id
        this.phoneCode.phone = this.phoneCode.phone.toString()
        this.phoneCode.code = this.phoneCode.code.toString()
        var fd = new FormData()
        fd.append('info',JSON.stringify(this.phoneCode))
        this.axios.post('/userinfo/changePhone',fd).then(res => {
          if(res.data.code === 0){
            this.user.phone = this.phoneCode.phone
            this.$message.success('修改成功')
          }else {
            this.$message.error(res.data.message)
          }
        })
      }
    },
    changeEmail(){
      if(!this.emailCode.email){
        this.$message.error('请输入邮箱号')
      }else {
        this.emailCode.id = this.user.id
        this.emailCode.email = this.emailCode.email.toString()
        this.emailCode.code= this.emailCode.code.toString()
        var fd = new FormData()
        fd.append('info',JSON.stringify(this.emailCode))
        this.axios.post('/userinfo/changeEmail',fd).then(res => {
          if(res.data.code === 0){
            this.user.email = this.emailCode.email
            this.$message.success('修改成功')
            this.emailDialogVisible = false
          }else {
            this.$message.error(res.data.message)
          }
        })
      }
    },
    loginOut(){
      this.$confirm('是否退出?', '退出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var userId = this.user.id

        this.axios.get('/login/logout/' + userId + '').then(res => {
          if(res.data.code === 0){
            localStorage.removeItem('id')
            localStorage.removeItem('token')
            this.$store.dispatch('UserInfo/clearnuserinfo')
            this.$router.replace('/')
          }else{
            this.$router.replace('/')
          }
        })
        // this.$message({
        //   type: 'success',
        //   message: '退出成功!'
        // });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }

  }
}
</script>

<style scoped>

.div_img_avatar{
  display: inline-block;
  width: 40%;
}

.div_img_avatar >>> img{
  padding-top: 2%;
  padding-left: 2%;
  width: 90%;
}

.div_userinfo_form{
  display: inline-block;
  width: 60%;
  padding-top: 7%;
  float: right;
}
.div_loginOut{
  display: inline-block;
  float: right;
  padding-right: 1%;
}
.demo-ruleForm {
  width: 65%;
}

.el-header {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  line-height: 100px;
}
.el-header >>> button {
  margin-right: 10%;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  /*line-height: 160px;*/
}
.dialog-footer {
  padding-top: 0;
  padding-bottom: 0;
}
</style>